export default __webpack_public_path__ + "static/5-eb0be629df931a01445ec033a19aed3a.jpg";